import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useClientHighlight } from "../../../Hooks/Features/ClientHighlight/useClientHighlight"
import { Dialog } from "primereact/dialog";
import PanelHeaderTemplate from "../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { MultiSelect } from "primereact/multiselect";
import CommanDialog from "../../../components/CommonCompo/CommanDialog/CommanDialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { SkeletonDataTable } from "../../../components/Loader/Loader";


const ClientHighlight = () => {

    const { showPopup, setShowPopup, option, formValue, setformValue, AddUserWithClient, rowData, removeClientUser, confirmationPopup, setConfirmationPopup, activeTemplate, deleteTemplate, loader } = useClientHighlight();

    return (
        <div>
            <div className="d-flex justify-content-end">
                {/* <div className="w15">
                    <MultiSelect
                        onChange={(e) => setFilterValue((prev) => ({ ...prev, users: e.target.value }))}
                        options={option?.userOption}
                        filter
                        filterInputAutoFocus
                        name="users"
                        placeholder="Users"
                        value={filterValue?.users}
                        optionLabel="user_display_name"
                        panelHeaderTemplate={(options) => PanelHeaderTemplate(
                            options, "user", filterValue?.users, () => { },
                            () => setFilterValue((prevState) => ({ ...prevState, users: [] })))
                        }
                    />
                </div> */}
                <div>
                    <button className="btn btn-primary" onClick={() => setShowPopup({
                        show: true,
                        type: "create"
                    })}>
                        <FontAwesomeIcon icon="fa-solid fa-add" /> Add
                    </button>
                </div>
            </div>
            {
                loader ? <SkeletonDataTable numSkeletons={2} /> : <DataTable
                    value={rowData}
                    rowGroupMode="rowspan"
                    groupRowsBy="user_display_name"
                    sortMode="single"
                    sortField="user_display_name"
                    sortOrder={1}
                    tableStyle={{ minWidth: "50rem" }}
                    scrollable
                    scrollHeight={"87vh"}
                    style={{ width: "70%" }}
                >
                    <Column field="user_display_name" header="Employee Name" style={{ width: "10%" }} />
                    <Column field="client_name" header="Client Name" style={{ width: "15%" }} />
                    <Column field="is_active" header="Active" body={activeTemplate} style={{ textAlign: "center", width: "10%" }} />
                    <Column header="Delete" body={deleteTemplate} style={{ textAlign: "center", width: "10%" }} />
                </DataTable>
            }

            <Dialog visible={showPopup?.show} onHide={() => setShowPopup({ shpw: false, type: "" })} className='modal-xsmall' draggable={false}
                header={() => {
                    return (
                        <div style={{ color: "black" }}>
                            Add Client in User
                        </div>
                    );
                }}>
                <div>
                    <div className="w100 d-flex flex-column align-items-center" >
                        <div className="w90">
                            <MultiSelect
                                onChange={(e) => setformValue((prev) => ({ ...prev, users: e.target.value }))}
                                options={option?.userOption}
                                filter
                                filterInputAutoFocus
                                name="users"
                                placeholder="Users"
                                value={formValue?.users}
                                optionLabel="user_display_name"
                                panelHeaderTemplate={(options) => PanelHeaderTemplate(
                                    options, "users", formValue?.users,
                                    () => { }, () => setformValue((prevState) => ({ ...prevState, users: [] })))
                                }
                            />
                        </div>
                        <div className="w90">
                            <MultiSelect
                                onChange={(e) => setformValue((prev) => ({ ...prev, clients: e.target.value }))}
                                name="clients"
                                options={option?.clientOption}
                                filter
                                filterInputAutoFocus
                                placeholder="Clients"
                                value={formValue?.clients}
                                optionLabel="client_name"
                                panelHeaderTemplate={(options) =>
                                    PanelHeaderTemplate(options, "clients", formValue?.clients,
                                        () => { }, () => setformValue((prevState) => ({
                                            ...prevState,
                                            clients: [],
                                        }))
                                    )
                                }
                            />
                        </div>
                    </div>
                    <div className='d-flex justify-content-center mt-2'>
                        <button className="button btn-default" onClick={() => setShowPopup({ shpw: false, type: "" })}>Cancel</button>
                        <button className="button btn-primary" onClick={() => AddUserWithClient(null, null)}>Submit</button>
                    </div>
                </div>
            </Dialog>
            <CommanDialog visible={confirmationPopup?.show} handleClose={() => setConfirmationPopup({ show: false, data: [] })} handleFun={() => { AddUserWithClient(confirmationPopup?.data, confirmationPopup?.is_active); }} message={`Are you sure you want to ${confirmationPopup?.is_active ? "active" : "deactive"} client from this user?`} />
            <CommanDialog visible={confirmationPopup?.showDelete} handleClose={() => setConfirmationPopup({ showDelete: false, id: null })} handleFun={() => { removeClientUser(confirmationPopup?.id) }} message={`Are you sure you want to delete client from this user?`} />
        </div>
    )
}

export default ClientHighlight